import React, { useEffect, useRef, useState } from "react";
import { BASE_URL, FRONTEND_URL } from "../../config/axios";
import axios from "axios";
import { formatDate, formattedDate, formattedDateLong } from "../Date";
import { Modal } from "react-bootstrap";
import ResumeAddmodel from "./update_details/Basicdetails";
import usePermission from "../../config/permissions";
import { ToastContainer, toast } from "react-toastify";
import { customSortByKey, handleErrorToast, DateRangePicker } from "../CustomFunctions";
import { CircularGrid, CrossRed, DeleteDustbin, DropdownArrow, Eye, Filter, Office, ReDo, Refresh, SearchBig, SearchSmall, Sort, Tick, UpdatePencil } from "../AllSvg";
import DuplicateWarningModal from "./update_details/DuplicateAadharComponent";
import Loader from "../Loader";

const RejectResumeModel = ({ i, getResumelist }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    remarks: "",
    coordinateby: `${sessionStorage.getItem(
      "emp_code"
    )} - ${sessionStorage.getItem("name")} `,
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["remarks"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //
  const [loading, setLoading] = useState(false); //loading logic

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    const updatedformvalue = {
      ...formData,
      resume_list_status: "rejected",
      resume_list_action: false,
      coordinateby: `${sessionStorage.getItem(
        "emp_code"
      )} - ${sessionStorage.getItem("name")} `,
    };

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/jd/jobapplicantrejectionmail/${i.id}/`,
          updatedformvalue
        );

        if (res.status === 200) {
          await getResumelist();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="model-delete-button"
        title="Reject Resume"
        onClick={handleShow}
      >
        <CrossRed />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Reject : {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div className="flex-column">
              <label htmlFor="remarks" className="form-labels font-weight500    font-size-subheading">
                Reason for Rejection<span className="required"></span>
              </label>
              <textarea
                type="text"
                id="remarks"
                name="remarks"
                maxLength={200}
                placeholder="Remarks"
                onChange={handleInputChange}
                value={formData.remarks}
                className={`form-input-textarea   font-weight400  font-size-subheading ${errors.remarks ? "error" : inputState.remarks ? "success" : ""
                  }`}
              />
              {errors.remarks && (
                <span className="error-message font-size-text ">{errors.remarks}</span>
              )}
            </div>

            <b>
              Note :<br />
              This will Send an E-mail of Rejection to "{i.user_detail}"
            </b>

            <div className="button-models">
              <button className="model-button model-button-cancel font-weight500   " onClick={handleClose}>
                Close
              </button>
              <button
                className="model-button  font-weight500    model-button-submit"
                onClick={handleFormSubmitPut}
                disabled={loading}
              >
                Reject
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const DeleteResume = ({ i, getResumelist }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [loading, setLoading] = useState(false); //loading logic
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); //loading logic
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/jd/jobapplicant/${i.id}/`);

      if (res.status === 200) {
        await getResumelist();
        handleClose();
      } else {
        console.error(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId)
    } finally {
      setLoading(false); //loading logic
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete Resume"
        className="model-delete-button"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>

      <Modal show={show} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div className="bdy-div">
              <h3 className="task-Tab-heading  font-weight500    font-size-heading">
                Confirm Deletion of Resume of :
              </h3>
              {/* <p style={{ textAlign: 'center' }}>:</p> */}
              <p style={{ textAlign: "center" }}>Name : {i.name}</p>
              <p style={{ textAlign: "center" }}>
                Department : {i.department_name}
              </p>
              <p style={{ textAlign: "center" }}>
                Designation : {i.position_name}
              </p>
              <p style={{ textAlign: "center" }}>
                Applied Date : {formatDate(i.applied_date)}
              </p>
              <p style={{ textAlign: "center" }}>Type : {i.job_type}</p>

              <div className="button-models">
                <button
                  className="model-button model-button-cancel font-weight500   "
                  onClick={handleClose}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button  font-weight500    model-button-leave font-weight500    font-size-heading"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const UpdateJobPost = ({ i, getDatalist }) => {
  const [jobposition, setJobPosition] = useState([]);
  const [buffer, setBuffering] = useState(true); //buffering logic
  const getJobpositionlist = async () => {
    try {
      setBuffering(true); //buffering logic // Start Buffering
      const res = await axios.get(
        `${BASE_URL}/jd/jobpostfilter/active/${sessionStorage.getItem(
          "company_id"
        )}/`
      );
      setJobPosition(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false);// End Buffering
    }
  };

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    getJobpositionlist();
  };


  const [formData, setFormData] = useState({
    remarks: "",
    jobpostdetails: i.jobpostdetails,
    coordinateby: `${sessionStorage.getItem(
      "emp_code"
    )} - ${sessionStorage.getItem("name")} `,
  });
  useEffect(() => {
    setFormData(i);
  }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["remarks"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      // upcoming_onboarding_status: 'approved',
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //
  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    const updatedformvalue = {
      ...formData,
      coordinateby: `${sessionStorage.getItem(
        "emp_code"
      )} - ${sessionStorage.getItem("name")} `,
    };

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/jd/jobapplicant/${i.id}/`,
          updatedformvalue
        );

        if (res.status === 200) {
          await getDatalist("pending");
          setShow(false);
        } else {
          console.error(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="model-edit-button-ml"
        title="Change Job Position"
        onClick={handleShow}
      >
        {/* <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 512 512" id="edit"><path d="M437.387,73H396V41.821a8,8,0,0,0-16,0V73H137V41.821a8,8,0,0,0-16,0V73H74.613C45.725,73,22,96.948,22,125.836V425.789C22,454.677,45.725,478,74.613,478H437.387C466.275,478,490,454.677,490,425.789V125.836C490,96.948,466.275,73,437.387,73ZM474,425.789C474,445.854,457.452,462,437.387,462H74.613C54.548,462,38,445.854,38,425.789V182H474ZM38,166V125.836C38,105.771,54.548,89,74.613,89H121v32.073a8,8,0,0,0,16,0V89H380v32.073a8,8,0,0,0,16,0V89h41.387C457.452,89,474,105.771,474,125.836V166Z"></path><path d="M145.833,434.167a7.959,7.959,0,0,0,1.8-.206l74.891-17.315a14.588,14.588,0,0,0,7.052-3.912L367.97,274.06a21.239,21.239,0,0,0-.015-29.982l-40.032-40.032a21.242,21.242,0,0,0-29.983-.016L159.269,342.423a14.582,14.582,0,0,0-3.916,7.05l-17.315,74.892a8,8,0,0,0,7.795,9.8ZM175.1,349.231,284.873,239.676,290.8,245.6,181.131,355.266ZM302.11,256.913l12.976,12.976L205.42,379.555l-12.975-12.976ZM222.771,396.905l-6.037-6.037L326.4,281.2l5.925,5.925Zm86.471-181.55a5.22,5.22,0,0,1,7.367,0l40.032,40.033a5.218,5.218,0,0,1,0,7.366L343.627,275.8,296.2,228.374ZM168.2,364.957,207.042,403.8l-50.529,11.683Z"></path></svg> */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          enable-background="new 0 0 36 42.002"
          overflow="visible"
          viewBox="0 0 36 42.002"
          id="job"
        >
          <path
            d="M18,24.754 M18,24.754c3.324,0,6,2.68,6,6c0,3.324-2.676,5.996-6,5.996s-6-2.672-6-5.996C12,27.434,14.676,24.754,18,24.754
	z M1.5,17.918c0.957,0.977,2.285,1.586,3.75,1.586h0.844c0.336,1.289,1.515,2.25,2.906,2.25c1.387,0,2.566-0.961,2.902-2.25h12.196
	c0.336,1.289,1.516,2.25,2.906,2.25c1.387,0,2.563-0.961,2.898-2.25h0.848c1.465,0,2.793-0.605,3.75-1.582v6.832
	c0,2.91-2.34,5.25-5.25,5.25h-3.785c-0.379-3.781-3.586-6.75-7.465-6.75s-7.082,2.969-7.465,6.75H6.75c-2.91,0-5.25-2.34-5.25-5.25
	V17.918z M27.004,17.254c0.836,0,1.492,0.66,1.492,1.5c0,0.836-0.656,1.5-1.492,1.5c-0.84,0-1.5-0.664-1.5-1.5
	C25.504,17.914,26.164,17.254,27.004,17.254z M9,17.254c0.836,0,1.5,0.66,1.5,1.5c0,0.836-0.664,1.5-1.5,1.5
	c-0.84,0-1.504-0.664-1.504-1.5C7.496,17.914,8.16,17.254,9,17.254z M6.75,6.004h22.5c2.91,0,5.25,2.34,5.25,5.246v3
	c0,2.082-1.672,3.754-3.75,3.754h-0.848c-0.332-1.289-1.508-2.25-2.898-2.25s-2.57,0.961-2.906,2.25H11.902
	c-0.332-1.289-1.511-2.25-2.902-2.25s-2.574,0.961-2.906,2.25H5.25c-2.078,0-3.75-1.672-3.75-3.754v-3
	C1.5,8.344,3.84,6.004,6.75,6.004z M15,1.5h6c0.426,0,0.75,0.332,0.75,0.754v2.25h-7.496v-2.25C14.254,1.832,14.578,1.5,15,1.5z
	 M15,0c-1.234,0-2.25,1.02-2.25,2.254v2.25h-6C3.031,4.504,0,7.531,0,11.25v13.504c0,3.719,3.031,6.75,6.75,6.75h3.785
	c0.379,3.785,3.586,6.75,7.465,6.75c1.797,0,3.449-0.637,4.746-1.695l5.227,5.227c0.293,0.289,0.766,0.289,1.055,0
	c0.297-0.293,0.297-0.77,0-1.063l-5.223-5.227c0.91-1.109,1.512-2.484,1.66-3.992h3.785c3.719,0,6.75-3.031,6.75-6.75V11.25
	c0-3.719-3.031-6.746-6.75-6.746h-6v-2.25C23.25,1.02,22.234,0,21,0H15z"
          ></path>
        </svg>
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Change Job Position of {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div className="flex-column ">
              <label htmlFor="jobpostdetails" className="form-labels font-weight500    font-size-subheading">
                Apply For
              </label>
              {buffer ?
                <div className="form-loader-date">
                  <div className="bar-loader"></div>
                </div>
                :
                <select
                  id="jobpostdetails"
                  name="jobpostdetails"
                  value={formData.jobpostdetails}
                  onChange={handleInputChange}
                  className={`form-input  ${errors.department
                    ? "error"
                    : inputState.department
                      ? "success"
                      : ""
                    }`}
                >
                  <option value="">Available post</option>
                  {jobposition
                    ?.sort((a, b) =>
                      a.department_name.localeCompare(b.department_name, "en", {
                        ignorePunctuation: true,
                      })
                    )
                    .map((i, index) => (
                      <>
                        <option value={i.id}>
                          {i.department_name} - {i.position_name}
                        </option>
                      </>
                    ))}
                </select>}
              <div>
                {errors.jobpostdetails && (
                  <span className="error-message font-size-text ">{errors.jobpostdetails}</span>
                )}
              </div>
            </div>

            <div className="flex-column">
              <label htmlFor="remarks" className="form-labels font-weight500    font-size-subheading">
                Reason<span className="required"></span>
              </label>
              <textarea
                type="text"
                id="remarks"
                name="remarks"
                placeholder="Remarks"
                onChange={handleInputChange}
                maxLength={200}
                value={formData.remarks}
                className={`form-input-textarea   font-weight400  font-size-subheading ${errors.remarks ? "error" : inputState.remarks ? "success" : ""
                  }`}
              />
              {errors.remarks && (
                <span className="error-message font-size-text ">{errors.remarks}</span>
              )}
            </div>

            <div className="button-models">
              <button className="model-button model-button-cancel font-weight500   " onClick={handleClose}>
                Close
              </button>
              <button
                className="model-button  font-weight500    model-button-submit"
                onClick={handleFormSubmitPut}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const InterviewScheduleModel = ({ i, getScreeninglist }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    interview_date: "",
    interview_status: "",
    interview_description: "",
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "interview_date",
      "interview_status",
      "interview_description",
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const updatedFormData = {
        ...formData,
        candidate_screening_status: "approved",
        candidate_screening_action: true,
      };
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/jd/jobapplicantinterviewmail/${i.id}/`,
          updatedFormData
        );

        if (res.status === 200) {
          await getScreeninglist();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="model-edit-button-ml"
        title="Schedule"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
        >
          <g clip-path="url(#clip0_719_1134)">
            <path
              d="M16.4127 2.5126C16.2712 2.37122 16.0946 2.27012 15.9011 2.21969C15.7076 2.16927 15.5041 2.17135 15.3116 2.22572H15.3011L1.80528 6.32072C1.58559 6.3839 1.39037 6.51251 1.24559 6.68941C1.10082 6.86631 1.01337 7.08312 0.994893 7.31096C0.976415 7.53881 1.02778 7.76687 1.14216 7.96479C1.25653 8.16271 1.42849 8.3211 1.63512 8.41885L7.65528 11.27L10.5065 17.2902C10.5965 17.483 10.7398 17.646 10.9194 17.76C11.0991 17.874 11.3076 17.9342 11.5204 17.9335C11.5527 17.9335 11.585 17.9321 11.6174 17.9293C11.8444 17.9109 12.0604 17.8236 12.2364 17.6789C12.4123 17.5342 12.5398 17.3392 12.6018 17.12L16.694 3.62424C16.694 3.62072 16.694 3.61721 16.694 3.61369C16.749 3.42171 16.752 3.21853 16.7026 3.02502C16.6532 2.83151 16.5531 2.65465 16.4127 2.5126ZM11.5267 16.798L11.5232 16.8078L8.75567 10.9656L12.0772 7.6433C12.1783 7.53695 12.2338 7.39534 12.2319 7.24867C12.23 7.10199 12.1709 6.96185 12.0672 6.85812C11.9635 6.75439 11.8233 6.69529 11.6766 6.69341C11.53 6.69154 11.3883 6.74703 11.282 6.84807L7.95973 10.1696L2.11677 7.40213H2.12661L15.6168 3.30854L11.5267 16.798Z"
              fill="#2576BC"
            />
          </g>
          <defs>
            <clipPath id="clip0_719_1134">
              <rect
                width="18"
                height="18"
                fill="white"
                transform="translate(0.429199 0.496094)"
              />
            </clipPath>
          </defs>
        </svg>
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Schedule Interview for "{i.name}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div className="flex-column">
              <label htmlFor="interview_date" className="form-labels font-weight500    font-size-subheading">
                Interview Date
              </label>
              <input
                type="date"
                id="interview_date"
                name="interview_date"
                placeholder="DD/MM/YYYY"
                autoComplete="off"
                onChange={handleInputChange}
                value={formData.interview_date}
                className={`form-input form-input-background ${errors.interview_date
                  ? "error"
                  : inputState.interview_date
                    ? "success"
                    : ""
                  }`}
              />
              {errors.interview_date && (
                <span className="error-message font-size-text ">{errors.interview_date}</span>
              )}
            </div>
            <div className="flex-column form-group-select">
              <label className="form-labels font-weight500    font-size-subheading" htmlFor="interview_status">
                Interview Mode<span className="required">*</span>
              </label>
              <br />
              <select
                id="interview_status"
                name="interview_status"
                value={formData.interview_status}
                onChange={handleInputChange}
                className={`form-input form-group-selection form-input-background ${errors.interview_status
                  ? "error"
                  : inputState.interview_status
                    ? "success"
                    : ""
                  }`}
              >
                <option value="">Type</option>
                <option value="physical">Physical</option>
                <option value="online">Online</option>
              </select>
              <DropdownArrow />
              <div>
                {errors.interview_status && (
                  <span className="error-message font-size-text ">
                    {errors.interview_status}
                  </span>
                )}
              </div>
            </div>

            <div className="flex-column">
              {formData.interview_status === "online" ? (
                <label className="form-labels font-weight500    font-size-subheading" htmlFor="interview_description">
                  Add Meeting Link
                </label>
              ) : (
                <label className="form-labels font-weight500    font-size-subheading" htmlFor="interview_description">
                  Add Office Address
                </label>
              )}
              <textarea
                name="interview_description"
                id="interview_description"
                className="form-input-textarea   font-weight400  form-input-background"
                placeholder=""
                type="text"
                value={formData.interview_description}
                onChange={handleInputChange}
              />

              {errors.interview_description && (
                <span className="error-message font-size-text ">
                  {errors.interview_description}
                </span>
              )}
            </div>
            <b>
              Note :<br />
              This will Send an E-mail for Scheduled Interview to "
              {i.user_detail}"
            </b>

            <div className="button-models">
              <button className="model-button model-button-cancel font-weight500   " onClick={handleClose}>
                Close
              </button>
              <button
                className="model-button  font-weight500    model-button-submit"
                onClick={handleFormSubmitPut}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const InterviewScheduleWalkinModel = ({ i, getScreeninglist }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Get current date in YYYY-MM-DD format
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [formData, setFormData] = useState({
    interview_date: getCurrentDate(),
    interview_status: "physical",
    interview_description: "Office Walkin Drive",
  });

  useEffect(() => {
    // Merge with existing data but keep walk-in defaults
    setFormData(prev => ({
      interview_date: getCurrentDate(),
      interview_status: "physical",
      interview_description: "Office Walkin Drive",
      ...i, // This will override defaults if i has these fields, so we need to be careful
    }));

    // Better approach - explicitly set only what we need from i
    setFormData({
      interview_date: getCurrentDate(),
      interview_status: "physical",
      interview_description: "Office Walkin Drive",
      // Only copy non-interview fields from i
      id: i.id,
      name: i.name,
      user_detail: i.user_detail,
      // ... any other fields you want to preserve
    });
  }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "interview_date",
      "interview_status",
      "interview_description",
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const updatedFormData = {
        ...formData,
        candidate_screening_status: "approved",
        candidate_screening_action: true,
      };
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        // Using the new walk-in API endpoint
        let res = await axios.put(
          `${BASE_URL}/jd/jobapplicant-candscreening-interviewwalkin/${i.id}/`,
          updatedFormData
        );

        if (res.status === 200) {
          await getScreeninglist();
          setShow(false);
          toast.success("Interview scheduled for walk-in drive!", { autoClose: 2000 });
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="model-edit-button-ml"
        title="Schedule Walk-in"
        onClick={handleShow}
      >
        <Tick color="#145650" />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Schedule Walk-in Drive for "{i.name}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div className="flex-column">
              <label htmlFor="interview_date" className="form-labels font-weight500 font-size-subheading">
                Interview Date
              </label>
              <input
                type="date"
                id="interview_date"
                name="interview_date"
                placeholder="DD/MM/YYYY"
                autoComplete="off"
                onChange={handleInputChange}
                value={formData.interview_date}
                className={`form-input form-input-background ${errors.interview_date
                  ? "error"
                  : inputState.interview_date
                    ? "success"
                    : "default-success" // Add green border by default
                  }`}
                style={{ borderColor: '#4CAF50' }} // Green border to indicate default
              />
              {errors.interview_date && (
                <span className="error-message font-size-text ">{errors.interview_date}</span>
              )}
            </div>

            {/* Interview Mode - Disabled since it's fixed to physical for walk-in */}
            <div className="flex-column">
              <label className="form-labels font-weight500 font-size-subheading" htmlFor="interview_status">
                Interview Mode (Fixed for Walk-in)
              </label>
              <select
                id="interview_status"
                name="interview_status"
                value={formData.interview_status}
                onChange={handleInputChange}
                disabled={true} // Disabled for walk-in
                className={`form-input form-input-background ${errors.interview_status
                  ? "error"
                  : "default-success"
                  }`}
              >
                <option value="physical">Physical</option>
              </select>
            </div>

            <div className="flex-column">
              <label className="form-labels font-weight500 font-size-subheading" htmlFor="interview_description">
                Location (Fixed)
              </label>
              <textarea
                name="interview_description"
                id="interview_description"
                className="form-input-textarea font-weight400 form-input-background"
                placeholder=""
                type="text"
                value={formData.interview_description}
                onChange={handleInputChange}
                disabled={true} // Disabled for walk-in
              />
            </div>

            <div className="info-message" style={{ padding: '10px', backgroundColor: '#e8f5e9', borderRadius: '5px', margin: '10px 0' }}>
              <b>Walk-in Drive Information:</b><br />
              • No email will be sent for this interview<br />
              • Candidate can directly visit the office on the scheduled date<br />
              • Default location: Office Walkin Drive<br />
              • Mode: Physical Interview
            </div>

            <b>
              Note :<br />
              This will schedule a Walk-in Drive for "{i.user_detail}" without sending an email.
            </b>

            <div className="button-models">
              <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                Close
              </button>
              <button
                className="model-button font-weight500 model-button-submit"
                onClick={handleFormSubmitPut}
              >
                Schedule Walk-in
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const RejectCandidateModel = ({ i, getScreeninglist }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    remarks: "",
    coordinateby: `${sessionStorage.getItem(
      "emp_code"
    )} - ${sessionStorage.getItem("name")} `,
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["remarks"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //
  const [loading, setLoading] = useState(false); //loading logic

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    const updatedformvalue = {
      ...formData,
      candidate_screening_status: "rejected",
      candidate_screening_action: false,
      coordinateby: `${sessionStorage.getItem(
        "emp_code"
      )} - ${sessionStorage.getItem("name")} `,
    };

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/jd/jobapplicant/${i.id}/`,
          updatedformvalue
        );

        if (res.status === 200) {
          await getScreeninglist();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="model-delete-button"
        title="Reject Candidate"
        onClick={handleShow}
      >
        <CrossRed />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Reject : {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div className="flex-column">
              <label htmlFor="remarks" className="form-labels font-weight500    font-size-subheading">
                Reason for Rejection<span className="required"></span>
              </label>
              <textarea
                type="text"
                id="remarks"
                name="remarks"
                placeholder="Remarks"
                maxLength={200}
                onChange={handleInputChange}
                value={formData.remarks}
                className={`form-input-textarea   font-weight400  font-size-subheading ${errors.remarks ? "error" : inputState.remarks ? "success" : ""
                  }`}
              />
              {errors.remarks && (
                <span className="error-message font-size-text ">{errors.remarks}</span>
              )}
            </div>

            <div className="button-models">
              <button className="model-button model-button-cancel font-weight500   " onClick={handleClose}>
                Close
              </button>
              <button
                className="model-button  font-weight500    model-button-submit"
                onClick={handleFormSubmitPut}
                disabled={loading}
              >
                Reject
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const UpdateInterviewDate = ({ i, getInterviewlist }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [filteredOnboarding, setFilteredOnboarding] = useState([]);

  const [formData, setFormData] = useState({
    remarks: "",
    interview_date: "",
    coordinateby: `${sessionStorage.getItem(
      "emp_code"
    )} - ${sessionStorage.getItem("name")} `,
  });
  useEffect(() => {
    setFormData(i);
  }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["remarks", "interview_date"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      // upcoming_onboarding_status: 'approved',
      // coordinateby: sessionStorage.getItem('emp_code'),
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    const updatedformvalue = {
      ...formData,
      coordinateby: `${sessionStorage.getItem(
        "emp_code"
      )} - ${sessionStorage.getItem("name")} `,
    };

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/jd/jobapplicant/${i.id}/`,
          updatedformvalue
        );

        if (res.status === 200) {
          await getInterviewlist("approved");
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="model-edit-button-ml"
        title="Change Interview Date"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="19"
          viewBox="0 0 512 512"
          id="edit"
        >
          <path d="M437.387,73H396V41.821a8,8,0,0,0-16,0V73H137V41.821a8,8,0,0,0-16,0V73H74.613C45.725,73,22,96.948,22,125.836V425.789C22,454.677,45.725,478,74.613,478H437.387C466.275,478,490,454.677,490,425.789V125.836C490,96.948,466.275,73,437.387,73ZM474,425.789C474,445.854,457.452,462,437.387,462H74.613C54.548,462,38,445.854,38,425.789V182H474ZM38,166V125.836C38,105.771,54.548,89,74.613,89H121v32.073a8,8,0,0,0,16,0V89H380v32.073a8,8,0,0,0,16,0V89h41.387C457.452,89,474,105.771,474,125.836V166Z"></path>
          <path d="M145.833,434.167a7.959,7.959,0,0,0,1.8-.206l74.891-17.315a14.588,14.588,0,0,0,7.052-3.912L367.97,274.06a21.239,21.239,0,0,0-.015-29.982l-40.032-40.032a21.242,21.242,0,0,0-29.983-.016L159.269,342.423a14.582,14.582,0,0,0-3.916,7.05l-17.315,74.892a8,8,0,0,0,7.795,9.8ZM175.1,349.231,284.873,239.676,290.8,245.6,181.131,355.266ZM302.11,256.913l12.976,12.976L205.42,379.555l-12.975-12.976ZM222.771,396.905l-6.037-6.037L326.4,281.2l5.925,5.925Zm86.471-181.55a5.22,5.22,0,0,1,7.367,0l40.032,40.033a5.218,5.218,0,0,1,0,7.366L343.627,275.8,296.2,228.374ZM168.2,364.957,207.042,403.8l-50.529,11.683Z"></path>
        </svg>
        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
            fill="#145650"
          />
        </svg> */}
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Change Interview Date for {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div className="flex-column">
              <label htmlFor="interview_date" className="form-labels font-weight500    font-size-subheading">
                Interview Date
              </label>
              <input
                type="date"
                id="interview_date"
                name="interview_date"
                placeholder="DD/MM/YYYY"
                autoComplete="off"
                onChange={handleInputChange}
                value={formData.interview_date}
                className={`form-input form-input-background ${errors.interview_date
                  ? "error"
                  : inputState.interview_date
                    ? "success"
                    : ""
                  }`}
              />
              {errors.interview_date && (
                <span className="error-message font-size-text ">{errors.interview_date}</span>
              )}
            </div>

            <div className="flex-column">
              <label htmlFor="remarks" className="form-labels font-weight500    font-size-subheading">
                Reason<span className="required"></span>
              </label>
              <textarea
                type="text"
                id="remarks"
                name="remarks"
                placeholder="Remarks"
                onChange={handleInputChange}
                maxLength={200}
                value={formData.remarks}
                className={`form-input-textarea   font-weight400  font-size-subheading ${errors.remarks ? "error" : inputState.remarks ? "success" : ""
                  }`}
              />
              {errors.remarks && (
                <span className="error-message font-size-text ">{errors.remarks}</span>
              )}
            </div>

            <div className="button-models">
              <button className="model-button model-button-cancel font-weight500   " onClick={handleClose}>
                Close
              </button>
              <button
                className="model-button  font-weight500    model-button-submit"
                onClick={handleFormSubmitPut}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const RemarkModel = ({ i, getJobDatalist }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    remarks: "",
    coordinateby: `${sessionStorage.getItem(
      "emp_code"
    )} - ${sessionStorage.getItem("name")} `,
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["remarks"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    const updatedformvalue = {
      ...formData,
      coordinateby: `${sessionStorage.getItem(
        "emp_code"
      )} - ${sessionStorage.getItem("name")} `,
    };

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.put(
          `${BASE_URL}/jd/jobapplicant/${i.id}/`,
          updatedformvalue
        );

        if (res.status === 200) {
          await getJobDatalist();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="model-edit-button-ml"
        title="Update Remarks"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          enable-background="new 0 0 70 70"
          viewBox="0 0 70 70"
          id="edit"
        >
          <path
            d="M45.338623,11.0065918H14.4987793c-1.9287109,0-3.4980469,1.5639648-3.4980469,3.4868164v41.0019531
	c0,1.9287109,1.5693359,3.4980469,3.4980469,3.4980469H45.338623c1.9287109,0,3.4980469-1.5693359,3.4980469-3.4980469V42.144043
	l9.1123047-9.1125488c1.4003906-1.3999023,1.4003906-3.6777344,0-5.0776367l-2.4541016-2.4545898
	c-1.4003906-1.4003906-3.6777344-1.4003906-5.078125,0l-1.5800781,1.5801392V14.4934082
	C48.8366699,12.5705566,47.267334,11.0065918,45.338623,11.0065918z M40.456543,47.6958008l-4.7038574-4.7038574
	L48.43927,30.3049927l4.7040405,4.7040405L40.456543,47.6958008z M34.9246826,44.9920654l3.5315552,3.5315552l-4.5199585,0.9883423
	L34.9246826,44.9920654z M46.8366699,55.4953613c0,0.8261719-0.671875,1.4980469-1.4980469,1.4980469H14.4987793
	c-0.8261719,0-1.4980469-0.671875-1.4980469-1.4980469V14.4934082c0-0.8198242,0.671875-1.4868164,1.4980469-1.4868164H45.338623
	c0.8261719,0,1.4980469,0.6669922,1.4980469,1.4868164v14.5860596l-8.0836182,8.0838623H18.7185059c-0.5527344,0-1,0.4477539-1,1
	s0.4472656,1,1,1h18.0346069l-3.121521,3.121582c-0.0849609,0.0846558-0.1463623,0.1864624-0.1954956,0.2943726
	c-0.0147095,0.0321045-0.0249634,0.0636597-0.0360107,0.0968628c-0.0115967,0.034668-0.0303345,0.0664673-0.0380249,0.102417
	l-0.156189,0.7143555H18.7185059c-0.5527344,0-1,0.4477539-1,1s0.4472656,1,1,1h14.0501099l-0.9464722,4.3291016H18.7185059
	c-0.5527344,0-1,0.4477539-1,1s0.4472656,1,1,1H32.626709c0.0712891,0,0.1425781-0.0073242,0.2138672-0.0229492l7.8300781-1.7119141
	c0.036377-0.0079956,0.0687256-0.0269775,0.1038208-0.0388794c0.0325928-0.0109863,0.0634766-0.0211792,0.0949707-0.0355835
	c0.1079712-0.0493774,0.2099609-0.1108398,0.2943726-0.1955566l5.6728516-5.6730347V55.4953613z M51.8308105,26.9133301
	c0.6210938-0.6201172,1.6289063-0.6201172,2.25,0l2.4541016,2.4545898c0.6201172,0.6201172,0.6201172,1.6293945,0,2.2495117
	l-1.9775391,1.9775391l-4.7041016-4.7041016L51.8308105,26.9133301z"
          ></path>
          <path d="M18.7185059 20.1750488h22.4042969c.5527344 0 1-.4477539 1-1s-.4472656-1-1-1H18.7185059c-.5527344 0-1 .4477539-1 1S18.1657715 20.1750488 18.7185059 20.1750488zM18.7185059 26.5046387h22.4042969c.5527344 0 1-.4477539 1-1s-.4472656-1-1-1H18.7185059c-.5527344 0-1 .4477539-1 1S18.1657715 26.5046387 18.7185059 26.5046387zM18.7185059 32.8337402h22.4042969c.5527344 0 1-.4477539 1-1s-.4472656-1-1-1H18.7185059c-.5527344 0-1 .4477539-1 1S18.1657715 32.8337402 18.7185059 32.8337402z"></path>
        </svg>
        {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <g clip-path="url(#clip0_1415_3177)">
              <path
                d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
                fill="#2576BC"
              />
            </g>
            <defs>
              <clipPath id="clip0_1415_3177">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg> */}
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Edit Remarks of {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div className="flex-column">
              <label htmlFor="remarks" className="form-labels font-weight500    font-size-subheading">
                Remarks<span className="required"></span>
              </label>
              <textarea
                type="text"
                id="remarks"
                name="remarks"
                placeholder="Remarks"
                onChange={handleInputChange}
                maxLength={200}
                value={formData.remarks}
                className={`form-input-textarea   font-weight400  font-size-subheading ${errors.remarks ? "error" : inputState.remarks ? "success" : ""
                  }`}
              />
              {errors.remarks && (
                <span className="error-message font-size-text ">{errors.remarks}</span>
              )}
            </div>

            <div className="button-models">
              <button className="model-button model-button-cancel font-weight500   " onClick={handleClose}>
                Close
              </button>
              <button
                className="model-button  font-weight500    model-button-submit"
                onClick={handleFormSubmitPut}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const ToOnboardingModel = ({ i, getInterviewlist }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    joining_date: "",
    remarks: "",
    coordinateby: `${sessionStorage.getItem(
      "emp_code"
    )} - ${sessionStorage.getItem("name")} `,
    upcoming_onboarding_status: "approved",
  });

  useEffect(() => {
    setFormData(i);
  }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["remarks", "joining_date"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      // upcoming_onboarding_status: 'approved',
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //
  const [loading, setLoading] = useState(false); //loading logic

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    const updatedformvalue = {
      ...formData,
      upcoming_onboarding_status: "approved",
      coordinateby: `${sessionStorage.getItem(
        "emp_code"
      )} - ${sessionStorage.getItem("name")} `,
    };

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.put(
          `${BASE_URL}/jd/jobapplicant/${i.id}/`,
          updatedformvalue
        );

        if (res.status === 200) {
          await getInterviewlist();
          setShow(false);
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        className="model-edit-button-ml"
        title="Onboarding"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
        >
          <g clip-path="url(#clip0_719_1134)">
            <path
              d="M16.4127 2.5126C16.2712 2.37122 16.0946 2.27012 15.9011 2.21969C15.7076 2.16927 15.5041 2.17135 15.3116 2.22572H15.3011L1.80528 6.32072C1.58559 6.3839 1.39037 6.51251 1.24559 6.68941C1.10082 6.86631 1.01337 7.08312 0.994893 7.31096C0.976415 7.53881 1.02778 7.76687 1.14216 7.96479C1.25653 8.16271 1.42849 8.3211 1.63512 8.41885L7.65528 11.27L10.5065 17.2902C10.5965 17.483 10.7398 17.646 10.9194 17.76C11.0991 17.874 11.3076 17.9342 11.5204 17.9335C11.5527 17.9335 11.585 17.9321 11.6174 17.9293C11.8444 17.9109 12.0604 17.8236 12.2364 17.6789C12.4123 17.5342 12.5398 17.3392 12.6018 17.12L16.694 3.62424C16.694 3.62072 16.694 3.61721 16.694 3.61369C16.749 3.42171 16.752 3.21853 16.7026 3.02502C16.6532 2.83151 16.5531 2.65465 16.4127 2.5126ZM11.5267 16.798L11.5232 16.8078L8.75567 10.9656L12.0772 7.6433C12.1783 7.53695 12.2338 7.39534 12.2319 7.24867C12.23 7.10199 12.1709 6.96185 12.0672 6.85812C11.9635 6.75439 11.8233 6.69529 11.6766 6.69341C11.53 6.69154 11.3883 6.74703 11.282 6.84807L7.95973 10.1696L2.11677 7.40213H2.12661L15.6168 3.30854L11.5267 16.798Z"
              fill="#2576BC"
            />
          </g>
          <defs>
            <clipPath id="clip0_719_1134">
              <rect
                width="18"
                height="18"
                fill="white"
                transform="translate(0.429199 0.496094)"
              />
            </clipPath>
          </defs>
        </svg>
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Start Onboarding for {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div className="flex-column">
              <label htmlFor="joining_date" className="form-labels font-weight500    font-size-subheading">
                Joining Date
              </label>
              <input
                type="date"
                id="joining_date"
                name="joining_date"
                placeholder="DD/MM/YYYY"
                autoComplete="off"
                onChange={handleInputChange}
                value={formData.joining_date}
                className={`form-input form-input-background ${errors.joining_date
                  ? "error"
                  : inputState.joining_date
                    ? "success"
                    : ""
                  }`}
              />
              {errors.joining_date && (
                <span className="error-message font-size-text ">{errors.joining_date}</span>
              )}
            </div>
            <div className="flex-column">
              <label htmlFor="remarks" className="form-labels font-weight500    font-size-subheading">
                Remarks<span className="required"></span>
              </label>
              <textarea
                type="text"
                id="remarks"
                name="remarks"
                placeholder="Remarks"
                onChange={handleInputChange}
                maxLength={200}
                value={formData.remarks}
                className={`form-input-textarea   font-weight400  font-size-subheading ${errors.remarks ? "error" : inputState.remarks ? "success" : ""
                  }`}
              />
              {errors.remarks && (
                <span className="error-message font-size-text ">{errors.remarks}</span>
              )}
            </div>

            <div className="button-models">
              <button className="model-button model-button-cancel font-weight500   " onClick={handleClose}>
                Close
              </button>
              <button
                className="model-button  font-weight500    model-button-submit"
                onClick={handleFormSubmitPut}
                disabled={loading}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const InterviewScheduleRound1to3 = ({ i, round, emp_codee }) => {
  // console.log(i)

  // console.log(emp_codee)
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const link = `${FRONTEND_URL}/applicantview/${round}/${i.jobpostdetails}/${i.user_detail
    }/  ${i.interview_status === "online"
      ? ` <br/> Meeting: ${i.interview_description}`
      : ""
    }`;
  // const content = `${FRONTEND_URL}/applicantview/${round}/${i.jobpostdetails}/${i.user_detail}/  \n  ${i.inte}`

  const [formData, setFormData] = useState({
    task: link,
    assignedby: sessionStorage.getItem("emp_code"),
    assigndate: formattedDate,
    concern_person: "",
    status: "pending",
    priority: "1",
    due_date: formattedDate,
    assignedtocc: [sessionStorage.getItem("emp_code")],
  });

  // useEffect(() => {
  //   setFormData(i);
  // }, [i]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmitPut = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      try {
        let res = await axios.post(`${BASE_URL}/wfm/tasks/`, formData);

        if (res.status === 200) {
          handleClose();
        } else {
          console.error(res);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button title={"Scedule Interview " + round} onClick={handleShow}>
        <label className="checkbox-click align-center">
          <input
            type="checkbox"
            checked={false}
            readOnly
          />
          <div className="checkmark-medium "></div>
        </label>
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Schedule Interview for {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <div className="parent-div">
            <div className="flex-column form-group-select">
              <label className="form-labels font-weight500    font-size-subheading">
                Assign To<span className="required">*</span>
              </label>
              <br />
              <select
                name="concern_person"
                onChange={handleInputChange}
                // value={formData.concern_person}
                className={`form-input form-group-selection form-input-background ${errors.concern_person
                  ? "error"
                  : inputState.concern_person
                    ? "success"
                    : ""
                  }`}
              >
                <option value="">Select Employee</option>
                {emp_codee
                  .sort((a, b) => a.emp_code - b.emp_code)
                  .map((i) => (
                    <option value={i.emp_code}>
                      <span>
                        {i.name} - {i.emp_code}
                      </span>
                    </option>
                  ))}
                ;
                {/* {emp_code.sort((a, b) => a.emp_code - b.emp_code).map((i) => (<option value={i.emp_code}>{i.emp_code} - {i.name}</option>))}; */}
              </select>
              <DropdownArrow />
            </div>
            <div className="button-models">
              <button className="model-button model-button-cancel font-weight500   " onClick={handleClose}>
                Close
              </button>
              <button
                className="model-button  font-weight500    model-button-submit"
                onClick={handleFormSubmitPut}
                disabled={loading}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const Resumelist = () => {
  const [designationname, setDesignationname] = useState([]);

  const [departmentname, setDepartmentname] = useState([]);
  const [selectedRemark, setRemark] = useState("");

  const [startdate, setStartDate] = useState("2026-01-01");
  const [enddate, setEndDate] = useState(null);

  const { SUB_COMPANIES, SUPER_ADMIN, PERMISSION_HR_ADMIN } = usePermission();

  const [toggleCompany, setToggleCompany] = useState(
    sessionStorage.getItem("company_id")
  );
  const [buffer1, setBuffering1] = useState(true); //buffering logic

  const getDepartmentandDesignation = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/designationfilterbysubcompanycount/${toggleCompany}/active/`
      );
      const ress = await axios.get(
        `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${toggleCompany}/active/`
      );

      setDesignationname(res.data);
      setDepartmentname(ress.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering1(false);// End Buffering
    }
  };

  useEffect(() => {
    getDepartmentandDesignation();
  }, [toggleCompany]);


  const [buffer, setBuffering] = useState(true); //buffering logic

  const [resumelist, setResumelist] = useState([]);
  const [resumelistfilter, setResumelistfilter] = useState([]);

  const [selectedName, setName] = useState("");
  const [selectedDep, setDep] = useState("");
  const [selectedDesi, setDesi] = useState("");
  const [selectedFromexp, setFromexp] = useState("");
  const [selectedToexp, setToexp] = useState("");
  const [toggleState, setToggleState] = useState("pending");
  // const [searchQuery, setSearchQuery] = useState("");

  const cancelTokenRef = useRef(null);
  const getResumelist = async (toggleState) => {

    if (cancelTokenRef.current) {
      cancelTokenRef.current.cancel('Request cancelled due to new request');
      cancelTokenRef.current = null;
    }

    setBuffering(true); // Start Buffering
    try {
      // Create new cancel token
      const source = axios.CancelToken.source();
      cancelTokenRef.current = source;

      const res = await axios.get(
        `${BASE_URL}/jd/jobapplicants-resumelist-bysubcompany-bystatus-byapplydate/${toggleCompany}/${toggleState || 'pending'}/${startdate || 'null'}/${enddate || 'null'}/`,
        { cancelToken: source.token }
      );
      setResumelist(res.data);
      cancelTokenRef.current = null; // Clear after successful request
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log('Previous request (Resume List) cancelled:', err.message);
      } else {
        handleErrorToast(err);
      }
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  // Also cancel on component unmount
  useEffect(() => {
    return () => {
      if (cancelTokenRef.current) {
        cancelTokenRef.current.cancel('Component unmounted');
      }
    };
  }, []);

  const applyFilters = () => {
    let filteredData = resumelist;

    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();
      filteredData = filteredData.filter((employee) => {
        const nameMatch = employee?.name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        const emailMatch = employee?.user_detail
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return nameMatch || emailMatch;
      });
    }

    if (selectedDep) {
      filteredData = filteredData.filter(
        (employee) => employee.department_name === selectedDep
      );
    }

    if (selectedFromexp) {
      const fromExpNumber = parseInt(selectedFromexp);
      filteredData = filteredData.filter(
        (employee) => parseInt(employee.yearofExp) >= fromExpNumber
      );
    }

    if (selectedToexp) {
      const toExpNumber = parseInt(selectedToexp);
      filteredData = filteredData.filter(
        (employee) => parseInt(employee.yearofExp) <= toExpNumber
      );
    }

    if (selectedDesi) {
      const lowercaseSelectedName = selectedDesi.toLowerCase();

      filteredData = filteredData.filter((employee) => {
        const desiMatch = employee.position_name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return desiMatch;
      });
    }
    if (selectedRemark) {
      const lowercaseSelectedRemark = selectedRemark.toLowerCase();

      filteredData = filteredData.filter((employee) => {
        const matchRemark = employee.remarks
          ?.toLowerCase()
          .includes(lowercaseSelectedRemark);

        return matchRemark;
      });
    }

    setResumelistfilter(filteredData);
  };



  useEffect(() => {
    applyFilters();
  }, [
    selectedName,
    selectedDep,
    selectedDesi,
    resumelist,
    selectedFromexp,
    selectedToexp,
    selectedRemark,
  ]);

  // ?  ************** Put Request Start **************  ! //

  const handlePending = async (e, id) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.put(`${BASE_URL}/jd/jobapplicant/${id}/`, {
        resume_list_status: "pending",
        resume_list_action: false,
      });

      if (res.status === 200) {
        await getResumelist();
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId)
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  const handleSelected = async (e, id) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.put(`${BASE_URL}/jd/jobapplicant/${id}/`, {
        resume_list_status: "approved",
        resume_list_action: true,
        accept_date: formattedDate,
      });

      if (res.status === 200) {
        await getResumelist();
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId)
    } finally {
      toast.dismiss(loadingToastId);
    }
  };
  useEffect(() => {
    getResumelist(toggleState);
  }, [toggleState, toggleCompany, startdate, enddate]);

  const refreshdata = async () => {
    setBuffering(true);
    await getResumelist(toggleState);
    setBuffering(false);
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

      <div className="attendance-history-cont">
        <div className="attendance-heading font-weight500    font-size-heading"></div>

        <div className="attendance-subcont">
          <div className="field-cont">
            {" "}
            <div title='Search Filter' className="field-cont-div">
              <SearchSmall />
              <input
                className="attendance-input-field width-15vw  "
                placeholder="Name or email"
                type="text"
                value={selectedName}
                onChange={(e) => setName(e.target.value)}
              />

              <hr className="field-cont-hr" />
            </div>

            <div title='Apply Date Range' className="field-cont-div ">
              <DateRangePicker
                startDate={startdate}
                endDate={enddate}
                placeHolder1="From Date"
                placeHolder2="To Date"
                onChange={(start, end) => {
                  setStartDate(start || '');
                  setEndDate(end || '');
                }}
              />
              <hr className="field-cont-hr" />
            </div>
            <div title="Department Filter" className="field-cont-div">
              <CircularGrid />
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDep}
                onChange={(e) => setDep(e.target.value)}
              >
                <option value=""> All Department</option>
                {/* {emp_code.sort((a, b) => a.emp_code - b.emp_code).map((i, index) => (<option value={i.emp_code}>{i.emp_code} - {i.name}</option>))}; */}
                {departmentname
                  .sort((a, b) => a.title - b.title)
                  .map((i, index) => (
                    <option value={i.title}>{i.title}</option>
                  ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>
            <div title="Designation Filter" className="field-cont-div">
              <CircularGrid />
              <input
                className="attendance-input-field width-10vw  "
                placeholder="Designation"
                type="text"
                value={selectedDesi}
                onChange={(e) => setDesi(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>
            {/* <div title="From Exp Filter" className="field-cont-div">
              <Filter />
              <input
                className="attendance-input-field width-5vw"
                placeholder="Form Exp"
                type="Number"
                value={selectedFromexp}
                onChange={(e) => setFromexp(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div> */}
            {/* <div title="To Exp Filter" className="field-cont-div">
              <Filter />
              <input
                className="attendance-input-field width-5vw"
                placeholder="To Exp"
                type="Number"
                value={selectedToexp}
                onChange={(e) => setToexp(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div> */}
            <div title="Remark Search Filter" className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-10vw  "
                placeholder="Remark"
                type="text"
                value={selectedRemark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </div>

          </div>
        </div>
      </div>
      <div className="table-css-white-background">
        <div className="table-heading-flex field-cont-between">
          <div className="repo-heading font-weight500    font-size-heading">
            Resume List
            {/* <p className='career-para font-size-subheading">Based your performance</p>          */}
          </div>
          <div className="field-cont">
            {SUPER_ADMIN ? (
              <div className="table-searchh dropdown-container field-cont-div">
                <Office />
                <select
                  onChange={(e) => setToggleCompany(e.target.value)}
                  value={toggleCompany}
                  className="dropdown font-size-subheading  "
                >
                  <option value="null">Select Sub Company</option>
                  {SUB_COMPANIES.map((company) => (
                    <option value={company.id}>{company.title}</option>
                  ))}
                  ;
                </select>
              </div>
            ) : null}
            <div>
              {
                PERMISSION_HR_ADMIN &&
                <ResumeAddmodel
                  departmentname={departmentname}
                  designationname={designationname}
                />}
            </div>
            {buffer ?
              <div className="spinner-vsmall"></div> :
              <div
                className="refresh-button"
                onClick={refreshdata}
                disabled={buffer}
              >
                <Refresh />
              </div>}
          </div>
        </div>

        <div className="table-heading-flex">
          <div className="bloc-tabs-with-white-bg bloc-tabs-with-lesswhite-bg">
            <button
              className={
                toggleState === "null"
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState("null")}
            >
              All
            </button>
            <button
              className={
                toggleState === "pending"
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState("pending")}
            >
              Pending
            </button>
            <button
              className={
                toggleState === "approved"
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState("approved")}
            >
              Approved
            </button>
            <button
              className={
                toggleState === "rejected"
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState("rejected")}
            >
              Rejected
            </button>
          </div>
        </div>
        <table className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">ID</th>
              <th className="align-leftt">Name</th>
              <th className="align-leftt">Email</th>
              <th className="align-leftt">Department</th>
              <th className="align-leftt">Position</th>
              <th className="align-leftt">Exp</th>
              <th className="align-center">Applied Date</th>
              <th className="align-center">Location</th>
              <th className="align-center">Remarks</th>
              <th className="align-center">Coordinator</th>
              <th className="align-center width-5vw">Action</th>
              <th className="align-center width-5vw">Form Details</th>
              <th className="align-right width-5vw">Update Application</th>
            </tr>
          </thead>

          {buffer ? (
            <Loader container={true} />
          ) : (
            <tbody>
              {resumelistfilter
                // .filter((e) =>
                //   e.name.toLowerCase().includes(searchQuery.toLowerCase())
                // )
                // .sort((a, b) => Date(a.date) - Date(b.date))
                .map((i, index) => {
                  return (
                    <React.Fragment key={index}>
                      <tr className="tr-border-bottom">
                        <td colSpan="6"></td>
                      </tr>
                      <tr
                        style={{
                          backgroundColor:
                            i.is_duplicate
                              ? "#fff3e0"
                              : "",
                        }}
                        title={"Resume Status : " + i.resume_list_status}
                        className="custom-table-head-tdd"
                      >
                        <td className="align-left">{index + 1}</td>
                        <td className="align-leftt">{i.name}</td>
                        <td className="align-leftt">{i?.user_detail}</td>
                        <td className="align-leftt">{i.department_name}</td>
                        <td className="align-leftt">{i.position_name}</td>
                        <td className="align-center">{i.yearofExp}</td>
                        <td className="align-center">
                          {formatDate(i.applied_date)}
                        </td>
                        {/* <td className="align-center">{i.job_type}</td> */}
                        <td className="align-center">{i.location}</td>
                        <td className="align-center">{i.remarks}</td>
                        <td className="align-center">{i.coordinateby}</td>
                        <td className="align-center width-5vw">
                          <div className="flex-row align-center justify-center">
                            {i.resume_list_status === "pending" ? (
                              <>
                                {i.details_filled ? (
                                  <button
                                    title="Approve"
                                    className="model-edit-button"
                                    onClick={(e) => handleSelected(e, i.id)}
                                  >
                                    <Tick color="#4f5554" />
                                  </button>
                                ) : (
                                  ""
                                )}{" "}
                                <RejectResumeModel
                                  i={i}
                                  getResumelist={getResumelist}
                                />
                              </>
                            ) : (
                              ""
                            )}

                            {i.resume_list_status === "approved" ? (
                              <>
                                <button
                                  title="Move to Pending"
                                  className="model-edit-button-ml"
                                  onClick={(e) => handlePending(e, i.id)}
                                >
                                  <ReDo />
                                </button>

                                <RejectResumeModel
                                  i={i}
                                  getResumelist={getResumelist}
                                />
                              </>
                            ) : (
                              ""
                            )}

                            {i.resume_list_status === "rejected" ? (
                              <>
                                <button
                                  title="Re-Assign"
                                  className="model-edit-button-ml"
                                  onClick={(e) => handlePending(e, i.id)}
                                >
                                  <ReDo />
                                </button>
                                {sessionStorage.getItem("role") === "Admin" ? (
                                  <DeleteResume
                                    i={i}
                                    getResumelist={getResumelist}
                                  />
                                ) : (
                                  ""
                                )}
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                        <td className="align-center width-5vw">
                          <div className="flex-row align-center justify-center">
                            <a
                              href={`${FRONTEND_URL}/personaldetails/${i.jobpostdetails}/${i.user_detail}/`}
                              className="model-edit-button"
                              target="_blank"
                              title="Edit Details"
                              rel="noopener noreferrer"
                            >
                              <UpdatePencil />
                            </a>
                            <a
                              href={`${FRONTEND_URL}/applicantview/${i.jobpostdetails}/${i.user_detail}/`}
                              target="_blank"
                              rel="noopener noreferrer"
                              title="View "
                            >
                              <Eye />
                            </a>
                            {i.is_duplicate ? (
                              <DuplicateWarningModal
                                applicant={i}
                                duplicates={i.duplicate_applications || []}
                              />
                            ) : (
                              // <span style={{ color: '#4CAF50', fontSize: '12px' }}>No duplicates</span>
                              null
                            )}
                          </div>
                        </td>

                        <td className="align-right  width-5vw ">
                          <div className="flex-row align-center justify-center">
                            <RemarkModel i={i} getJobDatalist={getResumelist} />
                            <UpdateJobPost i={i} getDatalist={getResumelist} />
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
            </tbody>
          )}
        </table>
      </div>
    </>
  );
};

const CandidateScreening = () => {
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();

  const [departmentname, setDepartmentname] = useState([]);
  const [selectedRemark, setRemark] = useState("");
  const [startdate, setStartDate] = useState("2026-01-01");
  const [enddate, setEndDate] = useState(null);
  const [toggleCompany, setToggleCompany] = useState(
    sessionStorage.getItem("company_id")
  );

  const [bufferdep, setBuffering1] = useState(true);
  const getDesignation = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const ress = await axios.get(
        `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${toggleCompany}/active/`
      );

      setDepartmentname(ress.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering1(false);// End Buffering
    }
  };

  useEffect(() => {
    getDesignation();
  }, [toggleCompany]);


  const [buffer, setBuffering] = useState(true); //buffering logic

  const [screeningList, setScreeningList] = useState([]);
  const [screeningListFilter, setScreeningListFilter] = useState([]);

  const [toggleState, setToggleState] = useState("pending");
  const [selectedName, setName] = useState("");
  const [selectedDep, setDep] = useState("");
  const [selectedDesi, setDesi] = useState("");
  const [selectedFromexp, setFromexp] = useState("");
  const [selectedToexp, setToexp] = useState("");

  const cancelTokenRef = useRef(null);
  const getScreeninglist = async (toggleState) => {

    if (cancelTokenRef.current) {
      cancelTokenRef.current.cancel('Request cancelled due to new request');
      cancelTokenRef.current = null;
    }

    setBuffering(true); //buffering logic // Start Buffering
    try {
      // Create new cancel token
      const source = axios.CancelToken.source();
      cancelTokenRef.current = source;

      const res = await axios.get(
        `${BASE_URL}/jd/jobapplicants-screeninglist-bysubcompany-bystatus-byapplydate/${toggleCompany}/${toggleState || 'pending'}/${startdate || 'null'}/${enddate || 'null'}/`,
        { cancelToken: source.token }
      );
      setScreeningList(res.data);
      cancelTokenRef.current = null; // Clear after successful request
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log('Previous request (Candidate Screening list) cancelled:', err.message);
      } else {
        handleErrorToast(err);
      }
    } finally {
      setBuffering(false);// End Buffering
    }
  };


  // Also cancel on component unmount
  useEffect(() => {
    return () => {
      if (cancelTokenRef.current) {
        cancelTokenRef.current.cancel('Component unmounted');
      }
    };
  }, []);

  const applyFilters = () => {
    let filteredData = screeningList;

    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();
      filteredData = filteredData.filter((employee) => {
        const nameMatch = employee?.name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        const emailMatch = employee?.user_detail
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return nameMatch || emailMatch;
      });
    }

    if (selectedDep) {
      filteredData = filteredData.filter(
        (employee) => employee.department_name === selectedDep
      );
    }

    if (selectedFromexp) {
      const fromExpNumber = parseInt(selectedFromexp);
      filteredData = filteredData.filter(
        (employee) => parseInt(employee.yearofExp) >= fromExpNumber
      );
    }

    if (selectedToexp) {
      const toExpNumber = parseInt(selectedToexp);
      filteredData = filteredData.filter(
        (employee) => parseInt(employee.yearofExp) <= toExpNumber
      );
    }

    if (selectedDesi) {
      const lowercaseSelectedName = selectedDesi.toLowerCase();

      filteredData = filteredData.filter((employee) => {
        const desiMatch = employee.position_name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return desiMatch;
      });
    }
    if (selectedRemark) {
      const lowercaseSelectedRemark = selectedRemark.toLowerCase();

      filteredData = filteredData.filter((employee) => {
        const matchRemark = employee.remarks
          ?.toLowerCase()
          .includes(lowercaseSelectedRemark);

        return matchRemark;
      });
    }

    setScreeningListFilter(filteredData);
  };

  useEffect(() => {
    applyFilters();
  }, [
    selectedName,
    selectedDep,
    selectedDesi,
    screeningList,
    selectedFromexp,
    selectedToexp,
    selectedRemark,
  ]);

  // ?  ************** Put Request Start **************  ! //

  const handlePending = async (e, id) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.put(`${BASE_URL}/jd/jobapplicant/${id}/`, {
        candidate_screening_status: "pending",
        candidate_screening_action: false,
      });

      if (res.status === 200) {
        await getScreeninglist();
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId)
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  useEffect(() => {
    getScreeninglist(toggleState);
  }, [toggleState, toggleCompany, startdate, enddate]);


  const refreshdata = async () => {
    setBuffering(true);
    await getScreeninglist(toggleState);
    setBuffering(false);
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="attendance-history-cont">
        <div className="attendance-heading font-weight500    font-size-heading"></div>

        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-15vw  "
                placeholder="Name or Email"
                type="text"
                value={selectedName}
                onChange={(e) => setName(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            <div title='Apply Date Range' className="field-cont-div ">
              <DateRangePicker
                startDate={startdate}
                endDate={enddate}
                placeHolder1="From Date"
                placeHolder2="To Date"
                onChange={(start, end) => {
                  setStartDate(start || '');
                  setEndDate(end || '');
                }}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-10vw"
                type="text"
                value={selectedDep}
                onChange={(e) => setDep(e.target.value)}
              >
                <option value=""> All Department</option>
                {/* {emp_code.sort((a, b) => a.emp_code - b.emp_code).map((i, index) => (<option value={i.emp_code}>{i.emp_code} - {i.name}</option>))}; */}
                {departmentname
                  .sort((a, b) => a.title - b.title)
                  .map((i, index) => (
                    <option value={i.title}>{i.title}</option>
                  ))}
                ;
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <CircularGrid />
              <input
                className="attendance-input-field width-10vw  "
                placeholder="Designation"
                type="text"
                value={selectedDesi}
                onChange={(e) => setDesi(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-10vw  "
                placeholder="Remark"
                type="text"
                value={selectedRemark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="table-css-white-background">
        <div className="table-heading-flex field-cont-between">
          <div className="repo-heading font-weight500    font-size-heading">
            Candidate Screening
            {/* <p className='career-para font-size-subheading">Based your performance</p>          */}
          </div>
          <div className="flex-row gap-2">
            {PERMISSION_AUTHORITY ? (
              <div className="table-searchh dropdown-container field-cont-div">
                <select
                  onChange={(e) => setToggleCompany(e.target.value)}
                  value={toggleCompany}
                  className="dropdown font-size-subheading  "
                >
                  <option value="null">Select Sub Company</option>
                  {SUB_COMPANIES.map((company) => (
                    <option value={company.id}>{company.title}</option>
                  ))}
                  ;
                </select>
              </div>
            ) : null}
            {buffer ?
              <div className="spinner-vsmall"></div> :
              <div
                className="refresh-button"
                onClick={refreshdata}
                disabled={buffer}
              >
                <Refresh />
              </div>}
          </div>
        </div>

        <div className="table-heading-flex">
          <div className="bloc-tabs-with-white-bg bloc-tabs-with-lesswhite-bg">
            <button
              className={
                toggleState === "null"
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState("null")}
            >
              All
            </button>
            <button
              className={
                toggleState === "pending"
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState("pending")}
            >
              Pending
            </button>
            <button
              className={
                toggleState === "approved"
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState("approved")}
            >
              Approval
            </button>
            <button
              className={
                toggleState === "rejected"
                  ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                  : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
              }
              onClick={() => setToggleState("rejected")}
            >
              Rejected
            </button>
          </div>
        </div>
        <table className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">ID</th>
              <th className="align-leftt">Name</th>
              <th className="align-leftt">Email</th>
              <th className="align-left">Department</th>
              <th className="align-center">Position</th>
              <th className="align-center">Exp</th>
              <th className="align-center">Accepted Date</th>
              {toggleState === "approved" ? (
                <th className="align-center">Interview Date</th>
              ) : (
                ""
              )}
              <th className="align-center">Type</th>
              <th className="align-center">Remarks</th>
              <th className="align-center">Coordinator</th>
              <th className="align-center width-5vw">Action</th>
              <th className="align-right">View</th>
              <th className="align-right">Update Remarks</th>
            </tr>
          </thead>
          {buffer ?
            <Loader container={true} />//buffering logic
            :
            <tbody>
              {screeningListFilter.map((i, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr
                      title={"Screening Status: " + i.candidate_screening_status}
                      className="custom-table-head-tdd"
                    >
                      <td className="align-left">{index + 1}</td>
                      <td className="align-leftt">{i.name}</td>
                      <td className="align-leftt">{i?.user_detail}</td>
                      <td className="align-left">{i.department_name}</td>

                      <td className="align-center">{i.position_name}</td>
                      <td className="align-center">{i.yearofExp}</td>
                      <td className="align-center">
                        {formatDate(i.accept_date)}
                      </td>
                      {toggleState == "approved" ? (
                        <td className="align-center">
                          {formatDate(i.interview_date)}
                        </td>
                      ) : (
                        ""
                      )}
                      <td className="align-center">{i.job_type}</td>
                      <td className="align-center">{i.remarks}</td>
                      <td className="align-center">{i.coordinateby}</td>
                      <td className="align-center width-5vw">
                        <div className="flex-row align-center justify-center">
                          {i.candidate_screening_status === "pending" ? (
                            <>
                              {
                                sessionStorage.getItem('role') === 'Career' ?
                                  <InterviewScheduleWalkinModel
                                    i={i}
                                    getScreeninglist={getScreeninglist}
                                  />
                                  :
                                  <InterviewScheduleModel
                                    i={i}
                                    getScreeninglist={getScreeninglist}
                                  />
                              }
                              <RejectCandidateModel
                                i={i}
                                getScreeninglist={getScreeninglist}
                              />
                            </>
                          ) : (
                            ""
                          )}

                          {i.candidate_screening_status === "approved" ? (
                            <>
                              <button
                                title="Move to Pending"
                                className="model-edit-button"
                                onClick={(e) => handlePending(e, i.id)}
                              >
                                <ReDo />
                              </button>

                              <RejectCandidateModel
                                i={i}
                                getScreeninglist={getScreeninglist}
                              />
                            </>
                          ) : (
                            ""
                          )}

                          {i.candidate_screening_status === "rejected" ? (
                            <>
                              <button
                                title="Move to Pending"
                                className="model-edit-button"
                                onClick={(e) => handlePending(e, i.id)}
                              >
                                <ReDo />
                              </button>
                              <InterviewScheduleModel
                                i={i}
                                getScreeninglist={getScreeninglist}
                              />
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                      <td className="align-center">
                        <a
                          href={`${FRONTEND_URL}/applicantview/${i.jobpostdetails}/${i.user_detail}/`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Eye />
                        </a>
                      </td>

                      <td className="align-right  width-5vw ">
                        <div className="flex-row align-center justify-center">
                          <RemarkModel i={i} getJobDatalist={getScreeninglist} />
                          <UpdateJobPost i={i} getDatalist={getScreeninglist} />
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          }
        </table>
      </div>
    </>
  );
};

const InterviewSchedule = () => {
  // *********** Employee Code Api Start ***********
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(PERMISSION_AUTHORITY ? "null" :
    sessionStorage.getItem("company_id")
  );

  const [startdate, setStartDate] = useState("2026-01-01");
  const [enddate, setEndDate] = useState(null);

  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true); //buffering logic
  const [buffer2, setBuffering2] = useState(true); //buffering logic

  const [emp_codee, setEmp_codee] = useState([]);
  const getAllEmp_code = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
      );

      const sortedData = customSortByKey(res.data, "emp_code");

      setEmp_codee(sortedData);
      // setEmp_codee(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering1(false);// End Buffering
    }
  };

  useEffect(() => {
    getAllEmp_code();
  }, [toggleCompany]);

  // console.log(emp_codee)

  const [interviewList, setInterViewList] = useState([]);
  const [interviewListFilter, setInterViewListFilter] = useState([]);

  const [selectedName, setName] = useState("");
  const [selectedRemark, setRemark] = useState("");
  const [selectedStatus, setStatus] = useState("");

  const [selectedFromexp, setFromexp] = useState("");
  const [selectedToexp, setToexp] = useState("");
  const [round1, setRound1] = useState("");
  const [round2, setRound2] = useState("");
  const [round3, setRound3] = useState("");
  const [round4, setRound4] = useState("");
  const [action, setAction] = useState("");
  const [toggleState, setToggleState] = useState("pending");

  // console.log(round4)

  // const [searchQuery, setSearchQuery] = useState("");

  const cancelTokenRef = useRef(null);
  const getInterviewlist = async () => {

    if (cancelTokenRef.current) {
      cancelTokenRef.current.cancel('Request cancelled due to new request');
      cancelTokenRef.current = null;
    }

    setBuffering(true); //buffering logic // Start Buffering
    try {
      // Create new cancel token
      const source = axios.CancelToken.source();
      cancelTokenRef.current = source;

      const res = await axios.get(
        // `${BASE_URL}/jd/jobapplicantinterviewlist/${toggleState}`
        // `${BASE_URL}/jd/jobapplicantinterviewlist/${toggleCompany}/`
        // `${BASE_URL}/jd/jobapplicants-interviewlist-bysubcompany/${toggleCompany}/`,
        `${BASE_URL}/jd/jobapplicants-interviewlist-bysubcompany-byinterviewdate/${toggleCompany}/${startdate || 'null'}/${enddate || 'null'}/`,
        { cancelToken: source.token }
      );
      setInterViewList(res.data);
      cancelTokenRef.current = null; // Clear after successful request
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log('Previous request (Interview list) cancelled:', err.message);
      } else {
        handleErrorToast(err);
      }
    } finally {
      setBuffering(false);// End Buffering
    }
  };

  // Also cancel on component unmount
  useEffect(() => {
    return () => {
      if (cancelTokenRef.current) {
        cancelTokenRef.current.cancel('Component unmounted');
      }
    };
  }, []);

  const applyFilters = () => {
    let filteredData = interviewList;

    if (selectedName) {
      const lowercaseSelectedName = selectedName.toLowerCase();

      filteredData = filteredData.filter((employee) => {
        const nameMatch = employee?.name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        const nameMatchh = employee?.department_name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        const nameMatchhh = employee?.position_name
          .toLowerCase()
          .includes(lowercaseSelectedName);
        const emailMatch = employee?.user_detail
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return nameMatch || nameMatchh || nameMatchhh || emailMatch;
      });
    }


    if (selectedFromexp) {
      const fromExpNumber = parseInt(selectedFromexp);
      filteredData = filteredData.filter(
        (employee) => parseInt(employee.yearofExp) >= fromExpNumber
      );
    }

    if (selectedToexp) {
      const toExpNumber = parseInt(selectedToexp);
      filteredData = filteredData.filter(
        (employee) => parseInt(employee.yearofExp) <= toExpNumber
      );
    }

    if (round1) {
      filteredData = filteredData.filter((employee) => employee.round1);
    }

    if (round2) {
      filteredData = filteredData.filter((employee) => employee.round2);
    }

    if (round3) {
      filteredData = filteredData.filter((employee) => employee.round3);
    }

    if (round4) {
      filteredData = filteredData.filter((employee) => employee.round4);
    } else {
      filteredData = filteredData.filter((employee) => !employee.round4);
    }

    if (selectedStatus) {
      const lowercaseSelectedName = selectedStatus.toLowerCase();

      filteredData = filteredData.filter((employee) => {
        const nameMatch = employee.remarks
          .toLowerCase()
          .includes(lowercaseSelectedName);

        return nameMatch;
      });
    }

    if (selectedRemark) {
      const lowercaseSelectedRemark = selectedRemark.toLowerCase();

      filteredData = filteredData.filter((employee) => {
        const matchRemark = employee.remarks
          ?.toLowerCase()
          .includes(lowercaseSelectedRemark);

        return matchRemark;
      });
    }

    setInterViewListFilter(filteredData);
  };



  useEffect(() => {
    applyFilters();
  }, [
    selectedName,
    interviewList,
    selectedFromexp,
    selectedToexp,
    round1,
    round2,
    round3,
    round4,
    selectedStatus,
    selectedRemark,
  ]);

  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  const formattedDatee = `${year}-${month.toString().padStart(2, "0")}-${day
    .toString()
    .padStart(2, "0")}`;

  useEffect(() => {
    getInterviewlist();
  }, [toggleCompany, startdate, enddate]);

  const refreshdata = async () => {
    setBuffering(true);
    await getInterviewlist();
    setBuffering(false);
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="attendance-history-cont">
        <div className="attendance-heading font-weight500    font-size-heading"></div>

        <div className="attendance-subcont">
          <div className="field-cont">
            <div className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-15vw  "
                placeholder="Name or Email"
                type="text"
                value={selectedName}
                onChange={(e) => setName(e.target.value)}
              />

              <hr className="field-cont-hr" />
            </div>

            <div title='Interview Date Range' className="field-cont-div ">
              <DateRangePicker
                startDate={startdate}
                endDate={enddate}
                placeHolder1="From Date"
                placeHolder2="To Date"
                onChange={(start, end) => {
                  setStartDate(start || '');
                  setEndDate(end || '');
                }}
              />
              <hr className="field-cont-hr" />
            </div>

            {/* <div className="field-cont-div">
              <CircularGrid />
              <input
                className="attendance-input-field width-5vw "
                placeholder="Form Exp"
                type="Number"
                value={selectedFromexp}
                onChange={(e) => setFromexp(e.target.value)}
              />

              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <CircularGrid />
              <input
                className="attendance-input-field width-5vw"
                placeholder="To Exp"
                type="Number"
                value={selectedToexp}
                onChange={(e) => setToexp(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div> */}

            <div className="field-cont-div">
              <label htmlFor="round_1_check" className="input-color-light flex-row gap-2">Round 1
                <label className="checkbox-click">
                  <input
                    id="round_1_check"
                    name="round_1_check"
                    type="checkbox"
                    checked={round1}
                    onChange={(e) => setRound1(e.target.checked)}
                  />
                  <div className="checkmark-small"></div>
                </label>
              </label>
              <hr className="field-cont-hr" />
            </div>


            <div className="field-cont-div">
              <label htmlFor="round_2_check" className="input-color-light flex-row gap-2">Round 2
                <label className="checkbox-click">
                  <input
                    id="round_2_check"
                    type="checkbox"
                    checked={round2}
                    onChange={(e) => setRound2(e.target.checked)}
                  />
                  <div className="checkmark-small "></div>
                </label>
              </label>
              <hr className="field-cont-hr" />
            </div>


            <div className="field-cont-div">
              <label htmlFor="round_3_check" className="input-color-light flex-row gap-2">Round 3
                <label className="checkbox-click">
                  <input
                    id="round_3_check"
                    type="checkbox"
                    checked={round3}
                    onChange={(e) => setRound3(e.target.checked)}
                  />
                  <div className="checkmark-small "></div>
                </label>
              </label>
              <hr className="field-cont-hr" />
            </div>


            <div className="field-cont-div">
              <label htmlFor="round_4_check" className="input-color-light flex-row gap-2">Final Round
                <label className="checkbox-click">
                  <input
                    id="round_4_check"
                    type="checkbox"
                    checked={round4}
                    onChange={(e) => setRound4(e.target.checked)}
                  />
                  <div className="checkmark-medium "></div>
                </label>
              </label>
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              <SearchBig />
              <input
                className="attendance-input-field width-10vw  "
                placeholder="Remark"
                type="text"
                value={selectedRemark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </div>
            {PERMISSION_AUTHORITY
              ?
              <div className="field-cont-div">
                <hr className="field-cont-hr" />
                <Office />
                <select
                  onChange={(e) => setToggleCompany(e.target.value)}
                  value={toggleCompany}
                  className="attendance-input-field width-10vw  "
                // className="dropdown font-size-subheading  "
                >
                  <option value="null">Select Sub Company</option>
                  {SUB_COMPANIES.map((company) => (
                    <option value={company.id}>{company.title}</option>
                  ))}
                  ;
                </select>

                <hr className="field-cont-hr" />
              </div> : null}
          </div>
        </div>
      </div>
      <div className="table-css-white-background">
        <div className="table-heading-flex field-cont-between">
          <div className="repo-heading font-weight500    font-size-heading">
            Interview schedule
          </div>
          <div>
            {buffer ?
              <div className="spinner-vsmall"></div> :
              <div
                className="refresh-button"
                onClick={refreshdata}
                disabled={buffer}
              >
                <Refresh />
              </div>}
          </div>
        </div>
        <table className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">ID</th>
              <th className="align-leftt">Name</th>
              <th className="align-leftt">Email</th>
              {/* <th className="align-center">Department</th> */}
              <th className="align-center">Designation</th>
              <th className="align-center">Interview Date</th>

              <th className="align-center">Exp</th>
              <th className="align-center">Round 1</th>
              <th className="align-center">Round 2</th>
              <th className="align-center">Round 3</th>
              <th className="align-center">Round 4</th>

              <th className="align-center">Remarks</th>
              <th className="align-center">Coordinator</th>
              <th className="align-center">Status</th>
              <th className="align-center">Updates </th>
              {round4 ? <th className="align-center">Onboarding</th> : ""}
            </tr>
          </thead>
          {buffer ?
            <Loader container={true} /> : //buffering logic
            <tbody>
              {interviewListFilter
                .sort(
                  (a, b) =>
                    new Date(b.interview_date) - new Date(a.interview_date)
                )
                .map((i, index) => {
                  const handleButtonClick = () => {
                    const url = `${FRONTEND_URL}/applicantview/${i.jobpostdetails}/${i.user_detail}/`;
                    window.open(url, "_blank", "noopener");
                  };
                  const handleAdminButtonClick = () => {
                    const url = `${FRONTEND_URL}/applicantview/round4/${i.jobpostdetails}/${i.user_detail}/`;
                    window.open(url, "_blank", "noopener");
                  };

                  return (
                    <React.Fragment key={index}>
                      <tr className="tr-border-bottom">
                        <td colSpan="10"></td>
                      </tr>
                      <tr
                        style={{
                          backgroundColor:
                            i.interview_date === formattedDatee
                              ? "#fbdfaf"
                              : "white",
                        }}
                        className="custom-table-head-td"
                      >
                        <td className="align-left">{index + 1}</td>
                        <td className="align-leftt">{i.name}</td>
                        <td className="align-leftt">{i?.user_detail}</td>
                        {/* <td className="align-center">{i.department_name}</td> */}
                        <td className="align-center">{i.position_name}</td>
                        <td className="align-center">
                          {formattedDateLong(i.interview_date)}
                        </td>
                        <td className="align-center">{i.yearofExp}</td>
                        <td className="align-center">
                          <>
                            {i.round1 ? (
                              <label className="checkbox-click align-center">
                                <input
                                  type="checkbox"
                                  checked={i.round1}
                                  readOnly
                                />
                                <div className="checkmark-medium "></div>
                              </label>
                            ) : (
                              <InterviewScheduleRound1to3
                                i={i}
                                round="round1"
                                emp_codee={emp_codee}
                              />
                            )}
                          </>
                        </td>
                        <td className="align-center">
                          <>
                            {i.round2 ? (
                              <label className="checkbox-click align-center">
                                <input
                                  type="checkbox"
                                  checked={i.round2}
                                  readOnly
                                />
                                <div className="checkmark-medium "></div>
                              </label>
                            ) : (
                              <InterviewScheduleRound1to3
                                i={i}
                                round="round2"
                                emp_codee={emp_codee}
                              />
                            )}
                          </>
                        </td>
                        <td className="align-center">
                          <>
                            {i.round3 ? (
                              <label className="checkbox-click align-center">
                                <input
                                  type="checkbox"
                                  checked={i.round3}
                                  readOnly
                                />
                                <div className="checkmark-medium "></div>
                              </label>
                            ) : (
                              <InterviewScheduleRound1to3
                                i={i}
                                round="round3"
                                emp_codee={emp_codee}
                              />
                            )}
                          </>
                        </td>
                        <td className="align-center">
                          <>
                            {sessionStorage.getItem("role") === "Admin" ? (
                              <button onClick={handleAdminButtonClick}>
                                <label className="checkbox-click align-center">
                                  <input
                                    type="checkbox"
                                    checked={i.round4}
                                    readOnly
                                  />
                                  <div className="checkmark-medium "></div>
                                </label>
                              </button>
                            ) : (
                              <button onClick={handleButtonClick}>
                                <label className="checkbox-click align-center">
                                  <input
                                    type="checkbox"
                                    checked={i.round4}
                                    readOnly
                                  />
                                  <div className="checkmark-medium "></div>
                                </label>
                              </button>
                            )}
                          </>
                        </td>
                        <td className="align-center">{i.remarks}</td>
                        <td className="align-center">{i.coordinateby}</td>

                        <td className="align-center">
                          <a
                            href={`${FRONTEND_URL}/applicantview/${i.jobpostdetails}/${i.user_detail}/`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Eye />
                          </a>
                        </td>

                        <td className="align-center">
                          <div className="flex-row align-center justify-center">
                            <UpdateInterviewDate
                              i={i}
                              getInterviewlist={getInterviewlist}
                            />
                            <RemarkModel i={i} getJobDatalist={getInterviewlist} />
                          </div>
                        </td>
                        {round4 ? (
                          <td className="align-center">
                            <ToOnboardingModel
                              i={i}
                              getInterviewlist={getInterviewlist}
                            />
                          </td>
                        ) : (
                          ""
                        )}
                      </tr>
                    </React.Fragment>
                  );
                })}
            </tbody>
          }
        </table>
      </div>
    </>
  );
};

export { Resumelist, CandidateScreening, InterviewSchedule };
